
import { Component, Vue } from 'vue-property-decorator';
import { OrderTaskStage } from '@/types/orderTask';
import Tasklist from './components/TaskList.vue';
import TaskSearch from './components/TaskSearch.vue';

@Component({
  name: 'taskTransfer',
  components: {
    Tasklist,
    TaskSearch
  }
})

export default class extends Vue {
  private stage =OrderTaskStage.Task_STAGE_TRANSFER;
}
